import React from 'react';
import { theme } from '../../theme';

const NAV_ITEMS = [
  { id: 'landing', icon: '🏠', label: 'Heim' },
  { id: 'browse', icon: '🔍', label: 'Leita' },
  { id: 'new-request', icon: '➕', label: 'Beiðni' },
  { id: 'my-page', icon: '👤', label: 'Mitt' },
];

export function BottomNav({ currentScreen, onNavigate }) {
  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: theme.maxWidth,
      background: theme.bgCard,
      borderTop: `1px solid ${theme.border}`,
      display: 'flex',
      justifyContent: 'space-around',
      padding: '8px 0 env(safe-area-inset-bottom, 8px)',
      zIndex: 100,
    }}>
      {NAV_ITEMS.map(item => {
        const isActive = currentScreen === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            style={{
              background: 'none',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
              padding: '8px 16px',
              cursor: 'pointer',
              minHeight: theme.touchTarget,
            }}
          >
            <span style={{ fontSize: '20px', opacity: isActive ? 1 : 0.5 }}>
              {item.icon}
            </span>
            <span style={{
              fontSize: '11px',
              color: isActive ? theme.accent : theme.textMuted,
              fontWeight: isActive ? 600 : 400,
            }}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
